import { useFileDownload } from 'src/hooks'

export const getAttachmentFileUrl = (attachmentId: number) =>
  `/platform/attachment/${attachmentId}/file`

export const useAttachmentDownload = (attachmentId: number) => {
  return useFileDownload(getAttachmentFileUrl(attachmentId))
}
